module.exports = __webpack_public_path__ + "static/img/third3_1_1_active.423efc68.jpg";